import { useMutation } from '@tanstack/react-query'
import { useSearchParams } from 'next/navigation'
import { toast } from 'react-toastify'
import { useContext } from 'react'

import { addError } from '@/global/plugins/observability'
import { upsertLead, UpsertLeadResponse } from '@/modules/simulator/api'
import {
  Context,
  SimulatorCode
} from '@/global/plugins/observability/observability.constants'
import { SimulatorContext } from '@/modules/simulator/contexts'
import { getTrackingInfoUtms } from '@/modules/simulator/functions/getTrackingInfoUtms/getTrackingInfoUtms'
import { getAnonymousId } from '@/global/utils'

interface UseUpsertLeadProps {
  onSuccess?: () => void
}

const useUpsertLead = ({ onSuccess }: UseUpsertLeadProps | undefined = {}) => {
  const searchParams = useSearchParams()
  const { simulation } = useContext(SimulatorContext)

  const onError = (error: Error) => {
    toast('Ops! Tivemos um problema, tente novamente.')
    addError({
      error,
      data: {
        context: Context.SIMULATOR,
        code: SimulatorCode.UPSERT_LEAD_ERROR,
        message: 'Erro ao finalizar simulação',
        location: 'useUpsertLead'
      }
    })
  }

  return useMutation<UpsertLeadResponse, Error>({
    mutationFn: () =>
      upsertLead({
        simulationId: simulation.id,
        payload: {
          trackingInfo: {
            ...(searchParams ? getTrackingInfoUtms(searchParams) : {}),
            anonymousId: getAnonymousId() || ''
          }
        }
      }),
    onError,
    onSuccess
  })
}

export { useUpsertLead }
